import { Loader } from '@/component/atoms/Loader'

import LoadingModalStyled from './LoadingModal.style'

export type LoadingModalProps = {
  children: React.ReactNode
}

const LoadingModal = ({ children }: LoadingModalProps) => {
  return (
    <LoadingModalStyled>
      <div className="loading-modal-layer">
        <Loader />
      </div>
      <div className="loading-modal-message">{children}</div>
    </LoadingModalStyled>
  )
}

export default LoadingModal
